/** @jsx h */
import { h } from 'preact'
import t from '../../../utils/translate'

const JourneyBrand = props => {
  const { organization, product } = props

  return (
    <div class='JourneyBrand'>
      <div>
        <div class='Avatar Avatar--xsmall'>
          <div class='Avatar-inner'>
            <img class='Avatar-media' src={organization.avatarUrl} alt='' />
          </div>
        </div>
      </div>
      <div class='JourneyBrand-details'>
        {product && <div class='Text-bodySansSmall'>{product.name}</div>}
        <div class='Text-bodySansSmallBold'>
          {t('journeys.js.cover.by', { organizationName: organization.name })}
        </div>
      </div>
    </div>
  )
}

export default JourneyBrand
